import Icon from '@ant-design/icons';
import { Layout, Space } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { SVGTemplate, SVGFlow, SVGMachine } from '../../images';
import { StyledMenu } from './styles';

export const menus = [
  {
    key: 'template',
    label: 'Template',
    title: 'Template',
    icon: (
      <Space direction="vertical" size={0} className="menu-custom-icon">
        <Icon component={SVGTemplate} />
        <span className="menu-custom-title">Template</span>
      </Space>
    ),
  },
  {
    key: 'machine',
    label: 'Machine',
    title: 'Machine',
    icon: (
      <Space direction="vertical" size={0} className="menu-custom-icon">
        <Icon component={SVGMachine} />
        <span className="menu-custom-title">Machine</span>
      </Space>
    ),
  },
  {
    key: 'flow',
    label: 'Flow (Coming soon)',
    title: 'Flow',
    icon: (
      <Space direction="vertical" size={0} className="menu-custom-icon">
        <Icon component={SVGFlow} />
        <span className="menu-custom-title">Flow</span>
      </Space>
    ),
  },
];

const Knowledge = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const { pathname } = location;

  const selectedKeys = pathname.split('/').slice(2);

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([]);

  return (
    <Layout style={{ height: '100%' }}>
      <Layout.Sider style={{ backgroundColor: '#3d5727' }} width={80}>
        <StyledMenu
          selectedKeys={selectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          theme="light"
          // mode="inline"
          inlineCollapsed
          items={menus}
          onClick={({ key, keyPath }) => {
            navigate(key);
            setDefaultOpenKeys(keyPath);
          }}
        />
      </Layout.Sider>
      <Layout.Content>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};

export default Knowledge;
